import { SUPER_GROUP_ID } from 'config';
import { pickGroup } from './pickGroup';
import { normalizePotentialActions } from './normalizePotentialActions';
function extractEmail(subject) {
    return Object.keys(subject.identity?.email || {})[0] || '';
}
export function buildAuthUser(firebaseUser, exchange) {
    const group = pickGroup(exchange.subject);
    const isAdmin = group.id === SUPER_GROUP_ID || Boolean(exchange.subject.principal?.admin);
    const principalUser = Object.values(exchange.subject.principal?.user || {})[0];
    return {
        email: extractEmail(exchange.subject),
        group,
        token: exchange.issuedAccessToken.accessToken,
        isEmailVerified: Boolean(firebaseUser?.emailVerified),
        isSupportSuperuser: group.id === SUPER_GROUP_ID,
        isRowiAdmin: isAdmin,
        accountName: typeof principalUser?.account_name === 'string' ? principalUser.account_name : '',
        accountRole: typeof principalUser?.account_role === 'string' ? principalUser.account_role : '',
        potentialActions: normalizePotentialActions(exchange.object?.potentialAction),
        profile: {
            displayName: firebaseUser?.displayName || '',
            photoURL: firebaseUser?.photoURL || '',
        },
        name: typeof principalUser?.name === 'string' ? principalUser.name : '',
    };
}
